module.exports = __webpack_public_path__ + "static/media/schlauch_frage.3741a00c.jpg";